import StatusBadge from '../../components/StatusBadge'
import './engagement.css'

/** Cell renderers the four engagement tables share. */

export const indexColumn = (header) => ({
  key: 'index',
  header,
  width: '64px',
  sortable: false,
  searchable: false,
  render: (_row, index) => <span className="eng__index">{index + 1}</span>,
})

export const dateColumn = (key, header) => ({
  key,
  header,
  render: (row) => (
    <span className="eng__date" dir="ltr">
      {row[key] ?? ''}
    </span>
  ),
})

export const statusColumn = (key, header, strings) => ({
  key,
  header,
  value: (row) => (row[key] ? strings.active : strings.inactive),
  render: (row) => (
    <StatusBadge tone={row[key] ? 'success' : 'dark'}>
      {row[key] ? strings.active : strings.inactive}
    </StatusBadge>
  ),
})

export const flagColumn = (key, header, strings) => ({
  key,
  header,
  align: 'center',
  value: (row) => (row[key] ? strings.yes : strings.no),
  render: (row) => (
    <StatusBadge tone={row[key] ? 'primary' : 'dark'} plain>
      {row[key] ? strings.yes : strings.no}
    </StatusBadge>
  ),
})
